var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkSecondary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D4F72289-B0F5-4CAC-A5A0-BFDBC6BC4871") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M17.3475,6 L9.6045,13.7138636 L6.648,10.7663137 L4.5,12.9101207 L9.6045,18 L19.5,8.14085201 L17.3475,6 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SYNC-&-Maps",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.0_SYNC-Home-Unauth:-NO-UPDATES",
    transform: "translate(-123.000000, -1057.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "accordion-A1-Copy",
    transform: "translate(99.000000, 1030.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-Good-Signal",
    transform: "translate(24.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#00095B",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Colour",
    mask: "url(#mask-2)",
    fill: "#008200"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Success---Object---#008200",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkSecondary);
export default __webpack_public_path__ + "static/media/checkmark-secondary.0050897a4568ab3df460cd0ce2cd49ca.svg";
export { ForwardRef as ReactComponent };